/* eslint-disable react/no-unknown-property */
import Head from 'next/head';
import React from 'react';

function AmpIncludeCustomElement({
  name,
  version,
}: {
  name: string;
  version: string;
}) {
  return (
    <Head>
      <script
        async
        custom-element={name}
        src={`https://cdn.ampproject.org/v0/${name}-${version}.js`}
        key={name}
      />
    </Head>
  );
}

export default AmpIncludeCustomElement;
